export const buttonMainStyle = {
  height: "44px",
  background: "#222",
  color: "#fff",
  fontFamily: "Plus Jakarta Sans",
  fontWeight: 700,
  fontSize: "15px",
  borderRadius: "22px",
  boxShadow: "none",
  padding: "0 24px",
  textTransform: "none"
}

export const exportIconButtonStyle = {
  ml: 2,
  height: "44px",
  width: "44px",
  background: "#ECF1F7",
  borderRadius: "50%"
}